<script>
    import {
        health, energy, hygiene, culture,
        iq, loneliness, confidence, stress,
        honesty, optimism, fitness,
        modal
    } from './stores.js';

    const ChannelEnum = Object.freeze({
        "news": 0,
        "art": 1,
        "food": 2
    });
    const ChannelInvEnum = Object.assign({}, ...Object.entries(ChannelEnum).map(([a,b]) => ({ [b]: a })))
    let channel = ChannelEnum.news;

    let next = () => { channel = (channel + 1) % 3 }
    let previous = () => { channel = (channel>0) ? (channel - 1) : ChannelEnum.food }
    let watch = () => {
        switch (channel) {
            case ChannelEnum.news:
                $optimism -= 0.07;
                $fitness -= 0.03;
                $loneliness += 0.07;
                $iq += 0.04;
                break;
            case ChannelEnum.art:
                $stress -= 0.1;
                $fitness -= 0.03;
                $loneliness += 0.07;
                $culture += 0.04;
                $energy += 0.15;
                break;
            case ChannelEnum.food:
                $stress -= 0.1;
                $fitness -= 0.03;
                // TODO: $basicCooking += 0.05;
            // TODO: implement more channels, research the period
        }
        modal.set();
        // TODO: progress time
        // TODO: refactor effects of channels to AloneActionsList
    }
</script>

<style>
    div {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    h1 {
        font-size: 2rem;
        text-align: center;
    }
    tv {
        display: block;
        width: 30vw;
        min-width: 300px;
        height: 30vw;
        min-height: 300px;
        background: url("https://images.unsplash.com/photo-1574974409771-cebec54deb00?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1332&q=80");
        background-size: cover;
    }
</style>

<div>
    <h1>Watch TV</h1>
    <h2>{ChannelInvEnum[channel]}</h2>
    <tv></tv>
    <sl-button-group>
        <sl-button size="large" on:click={previous}>◀</sl-button>
        <sl-button size="large" on:click={watch}>Watch</sl-button>
        <sl-button size="large" on:click={next}>▶</sl-button>
    </sl-button-group>
</div>
